<template>
  <div id="app" class="ceshi">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    if(navigator.language.indexOf("zh") != -1){
      this.$i18n.locale = 'zh-CN'
    } else {
      this.$i18n.locale = 'en-US'
    }
  }
}
</script>

<style scoped lang='less'>
// @import './common/font.css';
// body{
//   font-family: PingFang;
// }
.ceshi {
  overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue